/*
 * @Author: AI Assistant
 * @Date: 2026-01-15
 * @Description: 签到弹窗相关多语言配置（邀请好友、任务中心）
 * @FilePath: /weryai-web/locales/modules/signIn.ts
 */
export default {
    zh: {
        signIn: {
            // 邀请好友
            inviteFriends: '邀请好友',
            todayLimit: '今日上限',
            copyLink: '复制链接',
            copySuccess: '复制成功',
            validInvites: '有效邀请',
            people: '人',
            today: '今日',
            pending: '待领取',
            claimNow: '立即领取',
            claimSuccess: '领取成功',
            claimFailed: '领取失败，请稍后再试',
            noPendingRewards: '暂无可领取的奖励',
            forEachFriend: '邀请好友注册奖励',
            hotBadge: 'HOT',
            signUpsLabel: '注册',
            rechargeLabel: '充值',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: '好友通过你的链接注册并完成',
            inviteRegisterRuleAction: '一次AI生成',
            inviteRegisterRuleSuffix: '后发放奖励。',
            inviteDailyLimitText: '每日邀请奖励上限为{limit}人，次日自动刷新。',
            inviteFirstChargeTitle: '邀请好友首次充值奖励',
            inviteFirstChargeNote: '按受邀用户首次充值金额区间匹配奖励档位，仅首次充值有效，奖励不可叠加',
            inviteFirstChargeFootnote: '仅首次充值有效，奖励不可叠加',
            inviteLinkGeneratingTip: '邀请链接生成中，请稍后再试',
            copyFailedManual: '复制失败，请手动复制',
            altArrow: '箭头',
            altSignIn: '签到',
            altGift: '礼物',
            altBg: '背景',
            altPrize: '奖品',
            altSigned: '已签到',
            altCoin: '金币',
            ruleText: '规则：好友需通过您的链接注册并',
            completeGeneration: '完成一次AI生成',
            afterReward: '后发放奖励。',
            dailyLimitTip: '* 每日邀请奖励上限为 10 人，次日自动刷新。',
            promotionText:
                '想免费使用nanobanna、VEO、seedream?注册WeryAI就能领免费积分，立刻就能体验AI创作的乐趣！',
            // 任务中心
            taskCenter: '任务中心',
            addToDesktop: '将WeryAI添加到桌面并从桌面访问',
            addExtension: '添加反推插件到浏览器',
            goComplete: '去完成',
            completed: '已完成',
            tokens: '积分',
            // PWA 引导弹窗
            pwaGuideTitle: '把 WeryAI 放到桌面',
            pwaGuideDesc: '打开更快、更沉浸，不用每次找浏览器',
            browserNotSupported: '您的浏览器暂不支持此功能，建议使用 Chrome、Edge 或 Safari 浏览器',
            // PWA 步骤文案
            pwaStepChrome1: '点击顶部的添加到桌面的icon',
            pwaStepChrome2: '点击安装',
            pwaStepEdge1: '点击顶部的添加到桌面的icon',
            pwaStepEdge2: '点击安装',
            pwaStepSafari1: '点击更多icon',
            pwaStepSafari2: '点击分享',
            pwaStepSafari3: '点击更多',
            pwaStepSafari4: '点击添加到主屏幕',
            pwaStepSafari5: '点击添加',
            // PWA 提示卡片
            pwaPromptTitle: '将WeryAI添加到桌面',
            pwaPromptDesc: '添加到主屏幕，领取15积分奖励',
            pwaPromptBtn: '添加',
            extensionNotFound: '未检测到插件，请先安装并启用插件后再试。',
            generatingLink: '邀请链接生成中，请稍后再试',
            copyFailed: '复制失败，请手动复制',
            installExtensionGuide: '请在商店安装插件后，返回此处点击“立即领取”进行验证',
            extensionDetected: '检测到插件已安装，请点击领取奖励',
        },
    },
    en: {
        signIn: {
            // Invite Friends
            inviteFriends: 'Invite Friends',
            todayLimit: "Today's Limit",
            copyLink: 'Copy Link',
            copySuccess: 'Copied',
            validInvites: 'Valid Invites',
            people: 'people',
            today: 'Today',
            pending: 'Pending',
            claimNow: 'Claim Now',
            claimSuccess: 'Claimed successfully',
            claimFailed: 'Claim failed, please try again later',
            noPendingRewards: 'No rewards to claim',
            forEachFriend: 'Rewards for inviting friends to sign up',
            hotBadge: 'HOT',
            signUpsLabel: 'Sign-ups',
            rechargeLabel: 'Top-ups',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Friends register via your link and complete',
            inviteRegisterRuleAction: 'one AI generation',
            inviteRegisterRuleSuffix: 'to receive the reward.',
            inviteDailyLimitText: 'Daily invite reward limit is {limit} people, refreshes next day.',
            inviteFirstChargeTitle: "Reward for friends' first top-up",
            inviteFirstChargeNote:
                "Rewards are based on the invited user’s first top-up amount range. Only the first top-up counts, and rewards cannot be stacked.",
            inviteFirstChargeFootnote: 'Only the first top-up counts, and rewards cannot be stacked.',
            inviteLinkGeneratingTip: 'Invite link is being generated, please try again later',
            copyFailedManual: 'Copy failed, please copy manually',
            altArrow: 'Arrow',
            altSignIn: 'Sign in',
            altGift: 'Gift',
            altBg: 'Background',
            altPrize: 'Prize',
            altSigned: 'Signed',
            altCoin: 'Coin',
            ruleText: 'Rule: Friend must register via your link and',
            completeGeneration: 'complete one AI generation',
            afterReward: 'to receive reward.',
            dailyLimitTip:
                '* Daily invite reward limit is 10 people, refreshes next day.',
            promotionText:
                'Want to use nanobanna, VEO, seedream for free? Register WeryAI to get free tokens and experience the joy of AI creation!',
            // Task Center
            taskCenter: 'Task Center',
            addToDesktop: 'Add WeryAI to desktop and access from desktop',
            addExtension: 'Add reverse prompt extension to browser',
            goComplete: 'Go',
            completed: 'Completed',
            tokens: 'Credits',
            // PWA Guide Modal
            pwaGuideTitle: 'Put WeryAI on Your Desktop',
            pwaGuideDesc: 'Opens faster, more immersive, no need to find browser every time',
            browserNotSupported: 'Your browser does not support this feature. Please use Chrome, Edge, or Safari',
            // PWA Step Text
            pwaStepChrome1: 'Click the "Add to Desktop" icon at the top',
            pwaStepChrome2: 'Click Install',
            pwaStepEdge1: 'Click the "Add to Desktop" icon at the top',
            pwaStepEdge2: 'Click Install',
            pwaStepSafari1: 'Click the More icon',
            pwaStepSafari2: 'Click Share',
            pwaStepSafari3: 'Click More',
            pwaStepSafari4: 'Click Add to Home Screen',
            pwaStepSafari5: 'Click Add',
            // PWA Prompt Card
            pwaPromptTitle: 'Add WeryAI to Desktop',
            pwaPromptDesc: 'Add to home screen and get 15 tokens',
            pwaPromptBtn: 'Add',
            extensionNotFound: 'Extension not detected. Please install and enable it before trying again.',
            generatingLink: 'Generating invite link, please try again later',
            copyFailed: 'Copy failed, please copy manually',
            installExtensionGuide: 'Please install the extension from the store, then return here and click "Claim Now" to verify',
            extensionDetected: 'Extension installed. Click to claim your reward.',
        },
    },
    ja: {
        signIn: {
            inviteFriends: '友達を招待',
            todayLimit: '本日の上限',
            copyLink: 'リンクをコピー',
            copySuccess: 'コピーしました',
            validInvites: '有効な招待',
            people: '人',
            today: '今日',
            pending: '受取待ち',
            claimNow: '今すぐ受け取る',
            claimSuccess: '受け取りました',
            claimFailed: '受け取りに失敗しました。後でもう一度お試しください',
            noPendingRewards: '受け取れる報酬がありません',
            forEachFriend: '友達の登録招待報酬',
            hotBadge: 'HOT',
            signUpsLabel: '登録',
            rechargeLabel: 'チャージ',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: '友達があなたのリンクから登録し、',
            inviteRegisterRuleAction: 'AI生成を1回',
            inviteRegisterRuleSuffix: '完了すると報酬が付与されます。',
            inviteDailyLimitText: '1日の招待報酬上限は{limit}人で、翌日に自動更新されます。',
            inviteFirstChargeTitle: '友達の初回チャージ招待報酬',
            inviteFirstChargeNote:
                '招待されたユーザーの初回チャージ金額の範囲に応じて報酬が決まります。初回チャージのみ有効で、報酬は重複できません。',
            inviteFirstChargeFootnote: '初回チャージのみ有効で、報酬は重複できません。',
            inviteLinkGeneratingTip: '招待リンクを生成中です。しばらくしてからもう一度お試しください',
            copyFailedManual: 'コピーに失敗しました。手動でコピーしてください',
            altArrow: '矢印',
            altSignIn: 'サインイン',
            altGift: 'ギフト',
            altBg: '背景',
            altPrize: '賞品',
            altSigned: 'サイン済み',
            altCoin: 'コイン',
            ruleText: 'ルール：友達があなたのリンクから登録し、',
            completeGeneration: 'AI生成を1回完了',
            afterReward: 'すると報酬が付与されます。',
            dailyLimitTip:
                '* 1日の招待報酬上限は10人です。翌日に自動更新されます。',
            promotionText:
                'nanobanna、VEO、seedreamを無料で使いたいですか？WeryAIに登録すれば無料ポイントがもらえて、すぐにAI創作の楽しさを体験できます！',
            taskCenter: 'タスクセンター',
            addToDesktop: 'WeryAIをデスクトップに追加してアクセス',
            addExtension: 'ブラウザにリバースプロンプト拡張機能を追加',
            goComplete: '完了する',
            completed: '完了',
            tokens: 'クレジット',
            // PWA ガイドモーダル
            pwaGuideTitle: 'WeryAIをデスクトップに置く',
            pwaGuideDesc: 'より速く開き、より没入感があり、毎回ブラウザを探す必要がありません',
            browserNotSupported: 'お使いのブラウザはこの機能に対応していません。Chrome、Edge、またはSafariをご利用ください',
            // PWA ステップテキスト
            pwaStepChrome1: '上部の「デスクトップに追加」アイコンをクリック',
            pwaStepChrome2: 'インストールをクリック',
            pwaStepEdge1: '上部の「デスクトップに追加」アイコンをクリック',
            pwaStepEdge2: 'インストールをクリック',
            pwaStepSafari1: '「その他」アイコンをクリック',
            pwaStepSafari2: '共有をクリック',
            pwaStepSafari3: 'その他をクリック',
            pwaStepSafari4: '「ホーム画面に追加」をクリック',
            pwaStepSafari5: '追加をクリック',
            // PWA プロンプトカード
            pwaPromptTitle: 'WeryAIをデスクトップに追加',
            pwaPromptDesc: 'ホーム画面に追加して15ポイント獲得',
            pwaPromptBtn: '追加',
            extensionNotFound: '拡張機能が検出されませんでした。インストールして有効にしてからもう一度お試しください。',
            generatingLink: '招待リンクを生成中、後でもう一度お試しください',
            copyFailed: 'コピーに失敗しました。手動でコピーしてください',
            installExtensionGuide: 'ストアから拡張機能をインストールし、ここに戻って「今すぐ受け取る」をクリックして確認してください',
            extensionDetected: '拡張機能のインストールを検出しました。クリックして報酬を受け取ってください。',
        },
    },
    ko: {
        signIn: {
            inviteFriends: '친구 초대',
            todayLimit: '오늘 한도',
            copyLink: '링크 복사',
            copySuccess: '복사됨',
            validInvites: '유효 초대',
            people: '명',
            today: '오늘',
            pending: '수령 대기',
            claimNow: '지금 받기',
            claimSuccess: '수령 완료',
            claimFailed: '수령 실패, 나중에 다시 시도해주세요',
            noPendingRewards: '수령할 보상이 없습니다',
            forEachFriend: '친구 가입 초대 보상',
            hotBadge: 'HOT',
            signUpsLabel: '가입',
            rechargeLabel: '충전',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: '친구가 내 링크로 가입하고',
            inviteRegisterRuleAction: 'AI 생성 1회',
            inviteRegisterRuleSuffix: '완료하면 보상이 지급됩니다.',
            inviteDailyLimitText: '일일 초대 보상 한도는 {limit}명이며, 다음 날 자동 갱신됩니다.',
            inviteFirstChargeTitle: '친구 첫 충전 초대 보상',
            inviteFirstChargeNote:
                '초대된 사용자의 첫 충전 금액 구간에 따라 보상 등급이 매칭됩니다. 첫 충전만 유효하며 보상은 중복 지급되지 않습니다.',
            inviteFirstChargeFootnote: '첫 충전만 유효하며 보상은 중복 지급되지 않습니다.',
            inviteLinkGeneratingTip: '초대 링크를 생성 중입니다. 잠시 후 다시 시도해주세요',
            copyFailedManual: '복사에 실패했습니다. 수동으로 복사해주세요',
            altArrow: '화살표',
            altSignIn: '로그인',
            altGift: '선물',
            altBg: '배경',
            altPrize: '상품',
            altSigned: '완료됨',
            altCoin: '코인',
            ruleText: '규칙: 친구가 링크로 가입하고',
            completeGeneration: 'AI 생성 1회 완료',
            afterReward: ' 후 보상이 지급됩니다.',
            dailyLimitTip: '* 일일 초대 보상 한도는 10명이며, 다음 날 자동 갱신됩니다.',
            promotionText:
                'nanobanna, VEO, seedream을 무료로 사용하고 싶으신가요? WeryAI에 가입하면 무료 포인트를 받고 바로 AI 창작의 즐거움을 경험할 수 있습니다!',
            taskCenter: '태스크 센터',
            addToDesktop: 'WeryAI를 데스크톱에 추가하고 접속하기',
            addExtension: '브라우저에 역프롬프트 확장 프로그램 추가',
            goComplete: '완료하기',
            completed: '완료됨',
            tokens: '크레딧',
            // PWA 가이드 모달
            pwaGuideTitle: 'WeryAI를 데스크톱에 놓기',
            pwaGuideDesc: '더 빠르게 열리고, 더 몰입감 있고, 매번 브라우저를 찾을 필요 없음',
            browserNotSupported: '현재 브라우저는 이 기능을 지원하지 않습니다. Chrome, Edge 또는 Safari를 사용해 주세요',
            // PWA 단계 텍스트
            pwaStepChrome1: '상단의 "데스크톱에 추가" 아이콘을 클릭',
            pwaStepChrome2: '설치를 클릭',
            pwaStepEdge1: '상단의 "데스크톱에 추가" 아이콘을 클릭',
            pwaStepEdge2: '설치를 클릭',
            pwaStepSafari1: '더보기 아이콘 클릭',
            pwaStepSafari2: '공유 클릭',
            pwaStepSafari3: '더보기 클릭',
            pwaStepSafari4: '홈 화면에 추가 클릭',
            pwaStepSafari5: '추가 클릭',
            // PWA 프롬프트 카드
            pwaPromptTitle: 'WeryAI를 바탕화면에 추가',
            pwaPromptDesc: '홈 화면에 추가하고 15포인트 받기',
            pwaPromptBtn: '추가',
            extensionNotFound: '확장 프로그램이 감지되지 않았습니다. 설치 및 활성화 후 다시 시도해주세요.',
            generatingLink: '초대 링크 생성 중, 나중에 다시 시도해주세요',
            copyFailed: '복사 실패, 수동으로 복사해주세요',
            installExtensionGuide: '스토어에서 확장 프로그램을 설치한 후, 여기로 돌아와 "지금 받기"를 클릭하여 확인해주세요',
            extensionDetected: '확장 프로그램이 설치된 것을 감지했습니다. 클릭하여 보상을 받으세요.',
        },
    },
    es: {
        signIn: {
            inviteFriends: 'Invitar Amigos',
            todayLimit: 'Límite de Hoy',
            copyLink: 'Copiar Enlace',
            copySuccess: 'Copiado',
            validInvites: 'Invitaciones Válidas',
            people: 'personas',
            today: 'Hoy',
            pending: 'Pendiente',
            claimNow: 'Reclamar Ahora',
            claimSuccess: 'Reclamado con éxito',
            claimFailed: 'Error al reclamar, inténtalo más tarde',
            noPendingRewards: 'No hay recompensas para reclamar',
            forEachFriend: 'Recompensa por invitar a amigos a registrarse',
            hotBadge: 'HOT',
            signUpsLabel: 'Registros',
            rechargeLabel: 'Recargas',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Los amigos se registran con tu enlace y completan',
            inviteRegisterRuleAction: 'una generación de IA',
            inviteRegisterRuleSuffix: 'para recibir la recompensa.',
            inviteDailyLimitText:
                'El límite diario de recompensa por invitación es de {limit} personas; se actualiza al día siguiente.',
            inviteFirstChargeTitle: 'Recompensa por la primera recarga de tus amigos',
            inviteFirstChargeNote:
                'La recompensa se asigna según el rango del importe de la primera recarga del usuario invitado. Solo cuenta la primera recarga y las recompensas no se acumulan.',
            inviteFirstChargeFootnote:
                'Solo cuenta la primera recarga y las recompensas no se acumulan.',
            inviteLinkGeneratingTip:
                'El enlace de invitación se está generando, inténtalo de nuevo más tarde',
            copyFailedManual: 'Error al copiar, copia manualmente',
            altArrow: 'Flecha',
            altSignIn: 'Iniciar sesión',
            altGift: 'Regalo',
            altBg: 'Fondo',
            altPrize: 'Premio',
            altSigned: 'Completado',
            altCoin: 'Moneda',
            ruleText: 'Regla: Tu amigo debe registrarse con tu enlace y',
            completeGeneration: 'completar una generación de IA',
            afterReward: 'para recibir la recompensa.',
            dailyLimitTip:
                '* Límite diario de recompensa por invitación: 10 personas, se actualiza al día siguiente.',
            promotionText:
                '¿Quieres usar nanobanna, VEO, seedream gratis? ¡Regístrate en WeryAI para obtener tokens gratis y experimentar la alegría de la creación con IA!',
            taskCenter: 'Centro de Tareas',
            addToDesktop: 'Añadir WeryAI al escritorio y acceder desde ahí',
            addExtension: 'Añadir extensión de prompt inverso al navegador',
            goComplete: 'Ir',
            completed: 'Completado',
            tokens: 'Créditos',
            // Modal de guía PWA
            pwaGuideTitle: 'Pon WeryAI en tu escritorio',
            pwaGuideDesc: 'Se abre más rápido, más inmersivo, sin buscar el navegador cada vez',
            browserNotSupported: 'Tu navegador no soporta esta función. Por favor usa Chrome, Edge o Safari',
            // Texto de pasos PWA
            pwaStepChrome1: 'Haz clic en el icono "Añadir al escritorio" en la parte superior',
            pwaStepChrome2: 'Haz clic en Instalar',
            pwaStepEdge1: 'Haz clic en el icono "Añadir al escritorio" en la parte superior',
            pwaStepEdge2: 'Haz clic en Instalar',
            pwaStepSafari1: 'Haz clic en el icono Más',
            pwaStepSafari2: 'Haz clic en Compartir',
            pwaStepSafari3: 'Haz clic en Más',
            pwaStepSafari4: 'Haz clic en Añadir a pantalla de inicio',
            pwaStepSafari5: 'Haz clic en Añadir',
            // Tarjeta de solicitud PWA
            pwaPromptTitle: 'Añadir WeryAI al escritorio',
            pwaPromptDesc: 'Añadir a pantalla de inicio y obtener 15 puntos',
            pwaPromptBtn: 'Añadir',
            extensionNotFound: 'Extensión no detectada. Por favor, instálala y actívala antes de volver a intentarlo.',
            generatingLink: 'Generando enlace de invitación, por favor inténtalo más tarde',
            copyFailed: 'Error al copiar, por favor copia manualmente',
            installExtensionGuide: 'Por favor, instala la extensión desde la tienda, luego regresa aquí y haz clic en "Reclamar Ahora" para verificar',
            extensionDetected: 'Extensión detectada. Haz clic para reclamar tu recompensa.',
        },
    },
    fr: {
        signIn: {
            inviteFriends: 'Inviter des Amis',
            todayLimit: "Limite d'Aujourd'hui",
            copyLink: 'Copier le Lien',
            copySuccess: 'Copié',
            validInvites: 'Invitations Valides',
            people: 'personnes',
            today: "Aujourd'hui",
            pending: 'En Attente',
            claimNow: 'Réclamer',
            claimSuccess: 'Réclamé avec succès',
            claimFailed: 'Échec de la réclamation, réessayez plus tard',
            noPendingRewards: 'Aucune récompense à réclamer',
            forEachFriend: 'Récompense pour inviter des amis à s’inscrire',
            hotBadge: 'HOT',
            signUpsLabel: 'Inscriptions',
            rechargeLabel: 'Recharges',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Les amis s’inscrivent via votre lien et effectuent',
            inviteRegisterRuleAction: 'une génération IA',
            inviteRegisterRuleSuffix: 'pour recevoir la récompense.',
            inviteDailyLimitText:
                'La limite quotidienne de récompense d’invitation est de {limit} personnes, actualisée le lendemain.',
            inviteFirstChargeTitle: 'Récompense pour la première recharge des amis',
            inviteFirstChargeNote:
                'La récompense dépend de la tranche du montant de la première recharge de l’utilisateur invité. Seule la première recharge est valable, et les récompenses ne sont pas cumulables.',
            inviteFirstChargeFootnote:
                'Seule la première recharge est valable, et les récompenses ne sont pas cumulables.',
            inviteLinkGeneratingTip:
                'Le lien d’invitation est en cours de génération, veuillez réessayer plus tard',
            copyFailedManual: 'Échec de la copie, veuillez copier manuellement',
            altArrow: 'Flèche',
            altSignIn: 'Connexion',
            altGift: 'Cadeau',
            altBg: 'Arrière-plan',
            altPrize: 'Prix',
            altSigned: 'Terminé',
            altCoin: 'Pièce',
            ruleText: "Règle: Votre ami doit s'inscrire via votre lien et",
            completeGeneration: 'compléter une génération IA',
            afterReward: 'pour recevoir la récompense.',
            dailyLimitTip:
                "* Limite quotidienne de récompense d'invitation: 10 personnes, actualisée le lendemain.",
            promotionText:
                "Vous voulez utiliser nanobanna, VEO, seedream gratuitement? Inscrivez-vous sur WeryAI pour obtenir des tokens gratuits et découvrir la joie de la création IA!",
            taskCenter: 'Centre de Tâches',
            addToDesktop: "Ajouter WeryAI au bureau et y accéder",
            addExtension: 'Ajouter l\'extension de prompt inversé au navigateur',
            goComplete: 'Aller',
            completed: 'Terminé',
            tokens: 'Crédits',
            // Modal de guide PWA
            pwaGuideTitle: 'Mettez WeryAI sur votre bureau',
            pwaGuideDesc: 'S\'ouvre plus vite, plus immersif, sans chercher le navigateur à chaque fois',
            browserNotSupported: 'Votre navigateur ne prend pas en charge cette fonctionnalité. Veuillez utiliser Chrome, Edge ou Safari',
            // Texte des étapes PWA
            pwaStepChrome1: 'Cliquez sur l\'icône "Ajouter au bureau" en haut',
            pwaStepChrome2: 'Cliquez sur Installer',
            pwaStepEdge1: 'Cliquez sur l\'icône "Ajouter au bureau" en haut',
            pwaStepEdge2: 'Cliquez sur Installer',
            pwaStepSafari1: 'Cliquez sur l\'icône Plus',
            pwaStepSafari2: 'Cliquez sur Partager',
            pwaStepSafari3: 'Cliquez sur Plus',
            pwaStepSafari4: 'Cliquez sur Ajouter à l\'écran d\'accueil',
            pwaStepSafari5: 'Cliquez sur Ajouter',
            // Carte de demande PWA
            pwaPromptTitle: 'Ajouter WeryAI au bureau',
            pwaPromptDesc: "Ajouter à l'écran d'accueil et obtenir 15 points",
            pwaPromptBtn: 'Ajouter',
            extensionNotFound: 'Extension non détectée. Veuillez l\'installer et l\'activer avant de réessayer.',
            generatingLink: 'Génération du lien d\'invitation, veuillez réessayer plus tard',
            copyFailed: 'Échec de la copie, veuillez copier manuellement',
            installExtensionGuide: 'Veuillez installer l\'extension depuis le store, puis revenez ici et cliquez sur "Réclamer" pour vérifier',
            extensionDetected: 'Extension détectée. Cliquez pour réclamer votre récompense.',
        },
    },
    de: {
        signIn: {
            inviteFriends: 'Freunde Einladen',
            todayLimit: 'Heutiges Limit',
            copyLink: 'Link Kopieren',
            copySuccess: 'Kopiert',
            validInvites: 'Gültige Einladungen',
            people: 'Personen',
            today: 'Heute',
            pending: 'Ausstehend',
            claimNow: 'Jetzt Abholen',
            claimSuccess: 'Erfolgreich abgeholt',
            claimFailed: 'Abholen fehlgeschlagen, bitte später erneut versuchen',
            noPendingRewards: 'Keine Belohnungen zum Abholen',
            forEachFriend: 'Belohnung für die Einladung von Freunden zur Registrierung',
            hotBadge: 'HOT',
            signUpsLabel: 'Registrierungen',
            rechargeLabel: 'Aufladungen',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Freunde registrieren sich über deinen Link und schließen',
            inviteRegisterRuleAction: 'eine KI-Generierung ab',
            inviteRegisterRuleSuffix: 'um die Belohnung zu erhalten.',
            inviteDailyLimitText:
                'Das tägliche Einladungslimit für Belohnungen beträgt {limit} Personen und wird am nächsten Tag aktualisiert.',
            inviteFirstChargeTitle: 'Belohnung für die erste Aufladung von Freunden',
            inviteFirstChargeNote:
                'Die Belohnung richtet sich nach dem Betragsspannenbereich der ersten Aufladung des eingeladenen Nutzers. Nur die erste Aufladung zählt, und Belohnungen sind nicht kombinierbar.',
            inviteFirstChargeFootnote:
                'Nur die erste Aufladung zählt, und Belohnungen sind nicht kombinierbar.',
            inviteLinkGeneratingTip:
                'Der Einladungslink wird gerade erstellt, bitte später erneut versuchen',
            copyFailedManual: 'Kopieren fehlgeschlagen, bitte manuell kopieren',
            altArrow: 'Pfeil',
            altSignIn: 'Anmelden',
            altGift: 'Geschenk',
            altBg: 'Hintergrund',
            altPrize: 'Preis',
            altSigned: 'Abgeschlossen',
            altCoin: 'Münze',
            ruleText:
                'Regel: Ihr Freund muss sich über Ihren Link registrieren und',
            completeGeneration: 'eine KI-Generierung abschließen',
            afterReward: 'um die Belohnung zu erhalten.',
            dailyLimitTip:
                '* Tägliches Einladungslimit: 10 Personen, wird am nächsten Tag aktualisiert.',
            promotionText:
                'Möchten Sie nanobanna, VEO, seedream kostenlos nutzen? Registrieren Sie sich bei WeryAI und erhalten Sie kostenlose Tokens und erleben Sie die Freude der KI-Kreation!',
            taskCenter: 'Aufgabenzentrum',
            addToDesktop: 'WeryAI zum Desktop hinzufügen und darauf zugreifen',
            goComplete: 'Los',
            completed: 'Abgeschlossen',
            tokens: 'Credits',
            // PWA-Anleitungsmodal
            pwaGuideTitle: 'WeryAI auf den Desktop legen',
            pwaGuideDesc: 'Öffnet schneller, immersiver, ohne jedes Mal den Browser zu suchen',
            browserNotSupported: 'Ihr Browser unterstützt diese Funktion nicht. Bitte verwenden Sie Chrome, Edge oder Safari',
            // PWA-Schritttext
            pwaStepChrome1: 'Klicken Sie oben auf das Symbol "Zum Desktop hinzufügen"',
            pwaStepChrome2: 'Klicken Sie auf Installieren',
            pwaStepEdge1: 'Klicken Sie oben auf das Symbol "Zum Desktop hinzufügen"',
            pwaStepEdge2: 'Klicken Sie auf Installieren',
            pwaStepSafari1: 'Klicken Sie auf das Mehr-Symbol',
            pwaStepSafari2: 'Klicken Sie auf Teilen',
            pwaStepSafari3: 'Klicken Sie auf Mehr',
            pwaStepSafari4: 'Klicken Sie auf Zum Home-Bildschirm hinzufügen',
            pwaStepSafari5: 'Klicken Sie auf Hinzufügen',
            // PWA-Aufforderungskarte
            pwaPromptTitle: 'WeryAI zum Desktop hinzufügen',
            pwaPromptDesc: 'Zum Startbildschirm hinzufügen und 15 Punkte erhalten',
            pwaPromptBtn: 'Hinzufügen',
            extensionNotFound: 'Erweiterung nicht erkannt. Bitte installieren und aktivieren Sie sie, bevor Sie es erneut versuchen.',
            generatingLink: 'Einladungslink wird generiert, bitte versuchen Sie es später erneut',
            copyFailed: 'Kopieren fehlgeschlagen, bitte manuell kopieren',
            installExtensionGuide: 'Bitte installieren Sie die Erweiterung aus dem Store, kehren Sie dann hierher zurück und klicken Sie auf "Jetzt Abholen", um zu verifizieren',
            extensionDetected: 'Erweiterung erkannt. Klicken Sie, um Ihre Belohnung abzuholen.',
        },
    },
    ru: {
        signIn: {
            inviteFriends: 'Пригласить Друзей',
            todayLimit: 'Лимит Сегодня',
            copyLink: 'Копировать Ссылку',
            copySuccess: 'Скопировано',
            validInvites: 'Действительные Приглашения',
            people: 'человек',
            today: 'Сегодня',
            pending: 'Ожидает',
            claimNow: 'Получить Сейчас',
            claimSuccess: 'Успешно получено',
            claimFailed: 'Ошибка получения, попробуйте позже',
            noPendingRewards: 'Нет наград для получения',
            forEachFriend: 'Награда за приглашение друзей зарегистрироваться',
            hotBadge: 'HOT',
            signUpsLabel: 'Регистрации',
            rechargeLabel: 'Пополнения',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Друзья регистрируются по вашей ссылке и выполняют',
            inviteRegisterRuleAction: 'одну генерацию ИИ',
            inviteRegisterRuleSuffix: 'чтобы получить награду.',
            inviteDailyLimitText:
                'Дневной лимит награды за приглашения — {limit} человек, обновляется на следующий день.',
            inviteFirstChargeTitle: 'Награда за первое пополнение друзей',
            inviteFirstChargeNote:
                'Награда определяется по диапазону суммы первого пополнения приглашённого пользователя. Учитывается только первое пополнение, награды не суммируются.',
            inviteFirstChargeFootnote:
                'Учитывается только первое пополнение, награды не суммируются.',
            inviteLinkGeneratingTip: 'Ссылка приглашения генерируется, попробуйте позже',
            copyFailedManual: 'Не удалось скопировать, скопируйте вручную',
            altArrow: 'Стрелка',
            altSignIn: 'Войти',
            altGift: 'Подарок',
            altBg: 'Фон',
            altPrize: 'Приз',
            altSigned: 'Завершено',
            altCoin: 'Монета',
            ruleText:
                'Правило: Друг должен зарегистрироваться по вашей ссылке и',
            completeGeneration: 'выполнить одну генерацию ИИ',
            afterReward: 'для получения награды.',
            dailyLimitTip:
                '* Дневной лимит награды за приглашение: 10 человек, обновляется на следующий день.',
            promotionText:
                'Хотите бесплатно использовать nanobanna, VEO, seedream? Зарегистрируйтесь в WeryAI и получите бесплатные токены, чтобы испытать радость ИИ-творчества!',
            taskCenter: 'Центр Задач',
            addToDesktop: 'Добавить WeryAI на рабочий стол и открывать оттуда',
            addExtension: 'Добавить расширение обратного промпта в браузер',
            goComplete: 'Перейти',
            completed: 'Выполнено',
            tokens: 'Кредиты',
            // Модальное окно руководства PWA
            pwaGuideTitle: 'Разместите WeryAI на рабочем столе',
            pwaGuideDesc: 'Открывается быстрее, более погружающий, не нужно каждый раз искать браузер',
            browserNotSupported: 'Ваш браузер не поддерживает эту функцию. Пожалуйста, используйте Chrome, Edge или Safari',
            // Текст шагов PWA
            pwaStepChrome1: 'Нажмите на значок "Добавить на рабочий стол" вверху',
            pwaStepChrome2: 'Нажмите Установить',
            pwaStepEdge1: 'Нажмите на значок "Добавить на рабочий стол" вверху',
            pwaStepEdge2: 'Нажмите Установить',
            pwaStepSafari1: 'Нажмите на значок Ещё',
            pwaStepSafari2: 'Нажмите Поделиться',
            pwaStepSafari3: 'Нажмите Ещё',
            pwaStepSafari4: 'Нажмите Добавить на главный экран',
            pwaStepSafari5: 'Нажмите Добавить',
            // Карточка приглашения PWA
            pwaPromptTitle: 'Добавить WeryAI на рабочий стол',
            pwaPromptDesc: 'Добавить на главный экран и получить 15 баллов',
            pwaPromptBtn: 'Добавить',
            extensionNotFound: 'Расширение не обнаружено. Пожалуйста, установите и включите его перед повторной попыткой.',
            generatingLink: 'Создание ссылки для приглашения, пожалуйста, попробуйте позже',
            copyFailed: 'Ошибка копирования, пожалуйста, скопируйте вручную',
            installExtensionGuide: 'Пожалуйста, установите расширение из магазина, затем вернитесь сюда и нажмите "Получить Сейчас" для проверки',
            extensionDetected: 'Расширение обнаружено. Нажмите, чтобы получить награду.',
        },
    },
    pt: {
        signIn: {
            inviteFriends: 'Convidar Amigos',
            todayLimit: 'Limite de Hoje',
            copyLink: 'Copiar Link',
            copySuccess: 'Copiado',
            validInvites: 'Convites Válidos',
            people: 'pessoas',
            today: 'Hoje',
            pending: 'Pendente',
            claimNow: 'Resgatar Agora',
            claimSuccess: 'Resgatado com sucesso',
            claimFailed: 'Falha ao resgatar, tente novamente mais tarde',
            noPendingRewards: 'Não há recompensas para resgatar',
            forEachFriend: 'Recompensa por convidar amigos para se cadastrar',
            hotBadge: 'HOT',
            signUpsLabel: 'Cadastros',
            rechargeLabel: 'Recargas',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Os amigos se cadastram pelo seu link e concluem',
            inviteRegisterRuleAction: 'uma geração de IA',
            inviteRegisterRuleSuffix: 'para receber a recompensa.',
            inviteDailyLimitText:
                'O limite diário de recompensa por convite é de {limit} pessoas e é atualizado no dia seguinte.',
            inviteFirstChargeTitle: 'Recompensa pela primeira recarga dos amigos',
            inviteFirstChargeNote:
                'A recompensa é definida conforme a faixa do valor da primeira recarga do usuário convidado. Apenas a primeira recarga é válida e as recompensas não são cumulativas.',
            inviteFirstChargeFootnote:
                'Apenas a primeira recarga é válida e as recompensas não são cumulativas.',
            inviteLinkGeneratingTip:
                'O link de convite está sendo gerado, tente novamente mais tarde',
            copyFailedManual: 'Falha ao copiar, copie manualmente',
            altArrow: 'Seta',
            altSignIn: 'Entrar',
            altGift: 'Presente',
            altBg: 'Fundo',
            altPrize: 'Prêmio',
            altSigned: 'Concluído',
            altCoin: 'Moeda',
            ruleText: 'Regra: Seu amigo deve se registrar pelo seu link e',
            completeGeneration: 'completar uma geração de IA',
            afterReward: 'para receber a recompensa.',
            dailyLimitTip:
                '* Limite diário de recompensa por convite: 10 pessoas, atualizado no dia seguinte.',
            promotionText:
                'Quer usar nanobanna, VEO, seedream de graça? Registre-se no WeryAI para ganhar tokens grátis e experimentar a alegria da criação com IA!',
            taskCenter: 'Central de Tarefas',
            addToDesktop: 'Adicionar WeryAI à área de trabalho e acessar dali',
            addExtension: 'Adicionar extensão de prompt reverso ao navegador',
            goComplete: 'Ir',
            completed: 'Concluído',
            tokens: 'Créditos',
            // Modal de guia PWA
            pwaGuideTitle: 'Coloque o WeryAI na área de trabalho',
            pwaGuideDesc: 'Abre mais rápido, mais imersivo, sem precisar procurar o navegador toda vez',
            browserNotSupported: 'Seu navegador não suporta este recurso. Por favor, use Chrome, Edge ou Safari',
            // Texto das etapas PWA
            pwaStepChrome1: 'Clique no ícone "Adicionar à área de trabalho" no topo',
            pwaStepChrome2: 'Clique em Instalar',
            pwaStepEdge1: 'Clique no ícone "Adicionar à área de trabalho" no topo',
            pwaStepEdge2: 'Clique em Instalar',
            pwaStepSafari1: 'Clique no ícone Mais',
            pwaStepSafari2: 'Clique em Compartilhar',
            pwaStepSafari3: 'Clique em Mais',
            pwaStepSafari4: 'Clique em Adicionar à Tela de Início',
            pwaStepSafari5: 'Clique em Adicionar',
            // Cartão de solicitação PWA
            pwaPromptTitle: 'Adicionar WeryAI à área de trabalho',
            pwaPromptDesc: 'Adicionar à tela inicial e ganhar 15 pontos',
            pwaPromptBtn: 'Adicionar',
            extensionNotFound: 'Extensão não detectada. Instale e ative-a antes de tentar novamente.',
            generatingLink: 'Gerando link de convite, tente novamente mais tarde',
            copyFailed: 'Falha ao copiar, copie manualmente',
            installExtensionGuide: 'Instale a extensão na loja, retorne aqui e clique em "Resgatar Agora" para verificar',
            extensionDetected: 'Extensão detectada. Clique para resgatar sua recompensa.',
        },
    },
    it: {
        signIn: {
            inviteFriends: 'Invita Amici',
            todayLimit: 'Limite di Oggi',
            copyLink: 'Copia Link',
            copySuccess: 'Copiato',
            validInvites: 'Inviti Validi',
            people: 'persone',
            today: 'Oggi',
            pending: 'In Attesa',
            claimNow: 'Riscuoti Ora',
            claimSuccess: 'Riscosso con successo',
            claimFailed: 'Riscossione fallita, riprova più tardi',
            noPendingRewards: 'Nessuna ricompensa da riscuotere',
            forEachFriend: 'Ricompensa per invitare amici a registrarsi',
            hotBadge: 'HOT',
            signUpsLabel: 'Registrazioni',
            rechargeLabel: 'Ricariche',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Gli amici si registrano tramite il tuo link e completano',
            inviteRegisterRuleAction: 'una generazione IA',
            inviteRegisterRuleSuffix: 'per ricevere la ricompensa.',
            inviteDailyLimitText:
                'Il limite giornaliero di ricompensa per invito è di {limit} persone e si aggiorna il giorno successivo.',
            inviteFirstChargeTitle: 'Ricompensa per la prima ricarica degli amici',
            inviteFirstChargeNote:
                'La ricompensa dipende dalla fascia dell’importo della prima ricarica dell’utente invitato. Vale solo la prima ricarica e le ricompense non sono cumulabili.',
            inviteFirstChargeFootnote:
                'Vale solo la prima ricarica e le ricompense non sono cumulabili.',
            inviteLinkGeneratingTip:
                'Il link di invito è in fase di generazione, riprova più tardi',
            copyFailedManual: 'Copia non riuscita, copia manualmente',
            altArrow: 'Freccia',
            altSignIn: 'Accedi',
            altGift: 'Regalo',
            altBg: 'Sfondo',
            altPrize: 'Premio',
            altSigned: 'Completato',
            altCoin: 'Moneta',
            ruleText: 'Regola: Il tuo amico deve registrarsi tramite il tuo link e',
            completeGeneration: 'completare una generazione IA',
            afterReward: 'per ricevere la ricompensa.',
            dailyLimitTip:
                "* Limite giornaliero di ricompensa per invito: 10 persone, si aggiorna il giorno successivo.",
            promotionText:
                'Vuoi usare nanobanna, VEO, seedream gratis? Registrati su WeryAI per ottenere token gratuiti e provare la gioia della creazione con IA!',
            taskCenter: 'Centro Attività',
            addToDesktop: 'Aggiungi WeryAI al desktop e accedi da lì',
            addExtension: 'Aggiungi l\'estensione prompt inverso al browser',
            goComplete: 'Vai',
            completed: 'Completato',
            tokens: 'Crediti',
            // Modale guida PWA
            pwaGuideTitle: 'Metti WeryAI sul desktop',
            pwaGuideDesc: 'Si apre più veloce, più immersivo, senza cercare il browser ogni volta',
            browserNotSupported: 'Il tuo browser non supporta questa funzione. Per favore usa Chrome, Edge o Safari',
            // Testo dei passaggi PWA
            pwaStepChrome1: 'Clicca sull\'icona "Aggiungi al desktop" in alto',
            pwaStepChrome2: 'Clicca su Installa',
            pwaStepEdge1: 'Clicca sull\'icona "Aggiungi al desktop" in alto',
            pwaStepEdge2: 'Clicca su Installa',
            pwaStepSafari1: 'Clicca sull\'icona Altro',
            pwaStepSafari2: 'Clicca su Condividi',
            pwaStepSafari3: 'Clicca su Altro',
            pwaStepSafari4: 'Clicca su Aggiungi alla schermata Home',
            pwaStepSafari5: 'Clicca su Aggiungi',
            // Scheda di richiesta PWA
            pwaPromptTitle: 'Aggiungi WeryAI al desktop',
            pwaPromptDesc: 'Aggiungi alla schermata iniziale e ottieni 15 punti',
            pwaPromptBtn: 'Aggiungi',
            extensionNotFound: 'Estensione non rilevata. Installala e abilitala prima di riprovare.',
            generatingLink: 'Generazione del link di invito, riprova più tardi',
            copyFailed: 'Copia fallita, copia manualmente',
            installExtensionGuide: 'Installa l\'estensione dallo store, quindi torna qui e clicca su "Riscuoti Ora" per verificare',
            extensionDetected: 'Estensione rilevata. Clicca per riscuotere la tua ricompensa.',
        },
    },
    ar: {
        signIn: {
            inviteFriends: 'دعوة الأصدقاء',
            todayLimit: 'حد اليوم',
            copyLink: 'نسخ الرابط',
            copySuccess: 'تم النسخ',
            validInvites: 'الدعوات الصالحة',
            people: 'أشخاص',
            today: 'اليوم',
            pending: 'معلق',
            claimNow: 'استلم الآن',
            claimSuccess: 'تم الاستلام بنجاح',
            claimFailed: 'فشل الاستلام، حاول مرة أخرى لاحقًا',
            noPendingRewards: 'لا توجد مكافآت للاستلام',
            forEachFriend: 'مكافأة دعوة الأصدقاء للتسجيل',
            hotBadge: 'HOT',
            signUpsLabel: 'التسجيلات',
            rechargeLabel: 'عمليات الشحن',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'يسجّل الأصدقاء عبر رابطك ويُكملون',
            inviteRegisterRuleAction: 'عملية إنشاء ذكاء اصطناعي واحدة',
            inviteRegisterRuleSuffix: 'للحصول على المكافأة.',
            inviteDailyLimitText:
                'الحد اليومي لمكافأة الدعوات هو {limit} أشخاص ويتم التحديث في اليوم التالي.',
            inviteFirstChargeTitle: 'مكافأة أول عملية شحن للأصدقاء',
            inviteFirstChargeNote:
                'يتم تحديد المكافأة حسب نطاق مبلغ أول عملية شحن للمستخدم المدعو. تُحتسب أول عملية شحن فقط ولا يمكن تكديس المكافآت.',
            inviteFirstChargeFootnote:
                'تُحتسب أول عملية شحن فقط ولا يمكن تكديس المكافآت.',
            inviteLinkGeneratingTip: 'يتم إنشاء رابط الدعوة، يرجى المحاولة لاحقًا',
            copyFailedManual: 'فشل النسخ، يرجى النسخ يدويًا',
            altArrow: 'سهم',
            altSignIn: 'تسجيل الدخول',
            altGift: 'هدية',
            altBg: 'خلفية',
            altPrize: 'جائزة',
            altSigned: 'مكتمل',
            altCoin: 'عملة',
            ruleText: 'القاعدة: يجب على صديقك التسجيل عبر رابطك و',
            completeGeneration: 'إكمال عملية إنشاء ذكاء اصطناعي واحدة',
            afterReward: 'للحصول على المكافأة.',
            dailyLimitTip:
                '* حد المكافأة اليومي للدعوات: 10 أشخاص، يتم التحديث في اليوم التالي.',
            promotionText:
                'هل تريد استخدام nanobanna و VEO و seedream مجانًا؟ سجل في WeryAI للحصول على رموز مجانية واستمتع بتجربة إبداع الذكاء الاصطناعي!',
            taskCenter: 'مركز المهام',
            addToDesktop: 'أضف WeryAI إلى سطح المكتب والوصول منه',
            addExtension: 'إضافة ملحق المطالبة العكسية إلى المتصفح',
            goComplete: 'اذهب',
            completed: 'مكتمل',
            tokens: 'رصيد',
            // نافذة دليل PWA
            pwaGuideTitle: 'ضع WeryAI على سطح المكتب',
            pwaGuideDesc: 'يفتح أسرع، أكثر انغماسًا، دون الحاجة للبحث عن المتصفح في كل مرة',
            browserNotSupported: 'متصفحك لا يدعم هذه الميزة. يرجى استخدام Chrome أو Edge أو Safari',
            // نص خطوات PWA
            pwaStepChrome1: 'انقر على أيقونة "إضافة إلى سطح المكتب" في الأعلى',
            pwaStepChrome2: 'انقر على تثبيت',
            pwaStepEdge1: 'انقر على أيقونة "إضافة إلى سطح المكتب" في الأعلى',
            pwaStepEdge2: 'انقر على تثبيت',
            pwaStepSafari1: 'انقر على أيقونة المزيد',
            pwaStepSafari2: 'انقر على مشاركة',
            pwaStepSafari3: 'انقر على المزيد',
            pwaStepSafari4: 'انقر على إضافة إلى الشاشة الرئيسية',
            pwaStepSafari5: 'انقر على إضافة',
            // بطاقة طلب PWA
            pwaPromptTitle: 'أضف WeryAI إلى سطح المكتب',
            pwaPromptDesc: 'أضف إلى الشاشة الرئيسية واحصل على 15 نقطة',
            pwaPromptBtn: 'إضافة',
            extensionNotFound: 'لم يتم اكتشاف الملحق. يرجى تثبيته وتفعيله قبل المحاولة مرة أخرى.',
            generatingLink: 'جاري إنشاء رابط الدعوة، يرجى المحاولة لاحقًا',
            copyFailed: 'فشل النسخ، يرجى النسخ يدويًا',
            installExtensionGuide: 'يرجى تثبيت الملحق من المتجر، ثم العودة إلى هنا والنقر على "استلم الآن" للتحقق',
            extensionDetected: 'تم اكتشاف الإضافة. انقر للمطالبة بمكافأتك.',
        },
    },
    tw: {
        signIn: {
            // 邀請好友
            inviteFriends: '邀請好友',
            todayLimit: '今日上限',
            copyLink: '複製連結',
            copySuccess: '複製成功',
            validInvites: '有效邀請',
            people: '人',
            today: '今日',
            pending: '待領取',
            claimNow: '立即領取',
            claimSuccess: '領取成功',
            claimFailed: '領取失敗，請稍後再試',
            noPendingRewards: '暫無可領取的獎勵',
            forEachFriend: '邀請好友註冊獎勵',
            hotBadge: 'HOT',
            signUpsLabel: '註冊',
            rechargeLabel: '充值',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: '好友透過你的連結註冊並完成',
            inviteRegisterRuleAction: '一次AI生成',
            inviteRegisterRuleSuffix: '後發放獎勵。',
            inviteDailyLimitText: '每日邀請獎勵上限為{limit}人，次日自動刷新。',
            inviteFirstChargeTitle: '邀請好友首次充值獎勵',
            inviteFirstChargeNote:
                '按受邀用戶首次充值金額區間匹配獎勵檔位，僅首次充值有效，獎勵不可疊加',
            inviteFirstChargeFootnote: '僅首次充值有效，獎勵不可疊加',
            inviteLinkGeneratingTip: '邀請連結生成中，請稍後再試',
            copyFailedManual: '複製失敗，請手動複製',
            altArrow: '箭頭',
            altSignIn: '簽到',
            altGift: '禮物',
            altBg: '背景',
            altPrize: '獎品',
            altSigned: '已簽到',
            altCoin: '金幣',
            ruleText: '規則：好友需通過您的連結註冊並',
            completeGeneration: '完成一次AI生成',
            afterReward: '後發放獎勵。',
            dailyLimitTip: '* 每日邀請獎勵上限為 10 人，次日自動刷新。',
            promotionText:
                '想免費使用nanobanna、VEO、seedream?註冊WeryAI就能領免費積分，立刻就能體驗AI創作的樂趣！',
            // 任務中心
            taskCenter: '任務中心',
            addToDesktop: '將WeryAI添加到桌面並從桌面訪問',
            addExtension: '添加反推插件到瀏覽器',
            goComplete: '去完成',
            completed: '已完成',
            tokens: '積分',
            // PWA 引導彈窗
            pwaGuideTitle: '把 WeryAI 放到桌面',
            pwaGuideDesc: '開啟更快、更沉浸，不用每次找瀏覽器',
            browserNotSupported: '您的瀏覽器暫不支援此功能，建議使用 Chrome、Edge 或 Safari 瀏覽器',
            // PWA 步驟文案
            pwaStepChrome1: '點擊頂部的添加到桌面的icon',
            pwaStepChrome2: '點擊安裝',
            pwaStepEdge1: '點擊頂部的添加到桌面的icon',
            pwaStepEdge2: '點擊安裝',
            pwaStepSafari1: '點擊更多icon',
            pwaStepSafari2: '點擊分享',
            pwaStepSafari3: '點擊更多',
            pwaStepSafari4: '點擊添加到主螢幕',
            pwaStepSafari5: '點擊添加',
            // PWA 提示卡片
            pwaPromptTitle: '將WeryAI添加到桌面',
            pwaPromptDesc: '添加到主螢幕，領取15積分獎勵',
            pwaPromptBtn: '添加',
            extensionNotFound: '未檢測到插件，請先安裝並啟用插件後再試。',
            generatingLink: '邀請連結生成中，請稍後再試',
            copyFailed: '複製失敗，請手動複製',
            installExtensionGuide: '請在商店安裝插件後，返回此處點擊“立即領取”進行驗證',
            extensionDetected: '偵測到插件已安裝，請點擊領取獎勵',
        },
    },
    th: {
        signIn: {
            inviteFriends: 'เชิญเพื่อน',
            todayLimit: 'จำกัดวันนี้',
            copyLink: 'คัดลอกลิงก์',
            copySuccess: 'คัดลอกแล้ว',
            validInvites: 'คำเชิญที่ถูกต้อง',
            people: 'คน',
            today: 'วันนี้',
            pending: 'รอดำเนินการ',
            claimNow: 'รับเลย',
            claimSuccess: 'รับสำเร็จ',
            claimFailed: 'รับไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
            noPendingRewards: 'ไม่มีรางวัลให้รับ',
            forEachFriend: 'รางวัลจากการเชิญเพื่อนสมัครสมาชิก',
            hotBadge: 'HOT',
            signUpsLabel: 'สมัคร',
            rechargeLabel: 'เติมเงิน',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'เพื่อนลงทะเบียนผ่านลิงก์ของคุณและทำ',
            inviteRegisterRuleAction: 'การสร้าง AI 1 ครั้ง',
            inviteRegisterRuleSuffix: 'เพื่อรับรางวัล',
            inviteDailyLimitText: '* จำกัดรางวัลเชิญต่อวัน {limit} คน รีเฟรชวันถัดไป',
            inviteFirstChargeTitle: 'รางวัลจากการเชิญเพื่อนเติมเงินครั้งแรก',
            inviteFirstChargeNote:
                'รางวัลจะจับคู่ตามช่วงยอดเติมเงินครั้งแรกของผู้ใช้ที่ถูกเชิญ ใช้ได้เฉพาะการเติมเงินครั้งแรก และรางวัลไม่สามารถซ้อนทับได้',
            inviteFirstChargeFootnote:
                'ใช้ได้เฉพาะการเติมเงินครั้งแรก และรางวัลไม่สามารถซ้อนทับได้',
            inviteLinkGeneratingTip: 'กำลังสร้างลิงก์เชิญ กรุณาลองใหม่ภายหลัง',
            copyFailedManual: 'คัดลอกไม่สำเร็จ กรุณาคัดลอกด้วยตนเอง',
            altArrow: 'ลูกศร',
            altSignIn: 'เช็คอิน',
            altGift: 'ของขวัญ',
            altBg: 'พื้นหลัง',
            altPrize: 'รางวัล',
            altSigned: 'สำเร็จ',
            altCoin: 'เหรียญ',
            ruleText: 'กฎ: เพื่อนต้องลงทะเบียนผ่านลิงก์ของคุณและ',
            completeGeneration: 'สร้าง AI หนึ่งครั้ง',
            afterReward: 'เพื่อรับรางวัล',
            dailyLimitTip: '* จำกัดรางวัลเชิญต่อวัน 10 คน รีเฟรชวันถัดไป',
            promotionText:
                'อยากใช้ nanobanna, VEO, seedream ฟรีไหม? สมัคร WeryAI รับโทเคนฟรีและสัมผัสความสนุกของการสร้าง AI!',
            taskCenter: 'ศูนย์ภารกิจ',
            addToDesktop: 'เพิ่ม WeryAI ไปยังเดสก์ท็อปและเข้าถึงจากที่นั่น',
            addExtension: 'เพิ่มส่วนขยายพรอมต์ย้อนกลับไปยังเบราว์เซอร์',
            goComplete: 'ไป',
            completed: 'เสร็จสิ้น',
            tokens: 'เครดิต',
            pwaGuideTitle: 'วาง WeryAI บนเดสก์ท็อป',
            pwaGuideDesc: 'เปิดเร็วขึ้น ดื่มด่ำมากขึ้น ไม่ต้องหาเบราว์เซอร์ทุกครั้ง',
            browserNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับฟีเจอร์นี้ กรุณาใช้ Chrome, Edge หรือ Safari',
            pwaStepChrome1: 'คลิกไอคอน "เพิ่มไปยังเดสก์ท็อป" ด้านบน',
            pwaStepChrome2: 'คลิกติดตั้ง',
            pwaStepEdge1: 'คลิกไอคอน "เพิ่มไปยังเดสก์ท็อป" ด้านบน',
            pwaStepEdge2: 'คลิกติดตั้ง',
            pwaStepSafari1: 'คลิกไอคอนเพิ่มเติม',
            pwaStepSafari2: 'คลิกแชร์',
            pwaStepSafari3: 'คลิกเพิ่มเติม',
            pwaStepSafari4: 'คลิกเพิ่มไปยังหน้าจอหลัก',
            pwaStepSafari5: 'คลิกเพิ่ม',
            pwaPromptTitle: 'เพิ่ม WeryAI ไปยังเดสก์ท็อป',
            pwaPromptDesc: 'เพิ่มไปยังหน้าจอหลักและรับ 15 คะแนน',
            pwaPromptBtn: 'เพิ่ม',
            extensionNotFound: 'ไม่พบส่วนขยาย โปรดติดตั้งและเปิดใช้งานก่อนลองอีกครั้ง',
            generatingLink: 'กำลังสร้างลิงก์เชิญ โปรดลองอีกครั้งในภายหลัง',
            copyFailed: 'คัดลอกไม่สำเร็จ โปรดคัดลอกด้วยตนเอง',
            installExtensionGuide: 'โปรดติดตั้งส่วนขยายจากสโตร์ จากนั้นกลับมาที่นี่และคลิก "รับเลย" เพื่อยืนยัน',
            extensionDetected: 'ตรวจพบส่วนขยายแล้ว คลิกเพื่อรับรางวัลของคุณ',
        },
    },
    da: {
        signIn: {
            inviteFriends: 'Inviter venner',
            todayLimit: 'Dagens grænse',
            copyLink: 'Kopier link',
            copySuccess: 'Kopieret',
            validInvites: 'Gyldige invitationer',
            people: 'personer',
            today: 'I dag',
            pending: 'Afventer',
            claimNow: 'Hent nu',
            claimSuccess: 'Hentet med succes',
            claimFailed: 'Hentning mislykkedes, prøv igen senere',
            noPendingRewards: 'Ingen belønninger at hente',
            forEachFriend: 'Belønning for at invitere venner til at registrere sig',
            hotBadge: 'HOT',
            signUpsLabel: 'Tilmeldinger',
            rechargeLabel: 'Optankninger',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Venner registrerer sig via dit link og gennemfører',
            inviteRegisterRuleAction: 'én AI-generering',
            inviteRegisterRuleSuffix: 'for at modtage belønning.',
            inviteDailyLimitText:
                'Den daglige invitationsbelønningsgrænse er {limit} personer og opdateres næste dag.',
            inviteFirstChargeTitle: 'Belønning for venners første optankning',
            inviteFirstChargeNote:
                'Belønningen matches efter beløbsintervallet for den inviterede brugers første optankning. Kun første optankning gælder, og belønninger kan ikke kombineres.',
            inviteFirstChargeFootnote:
                'Kun første optankning gælder, og belønninger kan ikke kombineres.',
            inviteLinkGeneratingTip: 'Invitationslinket genereres, prøv igen senere',
            copyFailedManual: 'Kopiering mislykkedes, kopier venligst manuelt',
            altArrow: 'Pil',
            altSignIn: 'Log ind',
            altGift: 'Gave',
            altBg: 'Baggrund',
            altPrize: 'Præmie',
            altSigned: 'Fuldført',
            altCoin: 'Mønt',
            ruleText: 'Regel: Din ven skal registrere sig via dit link og',
            completeGeneration: 'gennemføre én AI-generering',
            afterReward: 'for at modtage belønning.',
            dailyLimitTip: '* Daglig invitationsbelønningsgrænse: 10 personer, opdateres næste dag.',
            promotionText:
                'Vil du bruge nanobanna, VEO, seedream gratis? Tilmeld dig WeryAI for at få gratis tokens og oplev glæden ved AI-skabelse!',
            taskCenter: 'Opgavecenter',
            addToDesktop: 'Tilføj WeryAI til skrivebordet og få adgang derfra',
            addExtension: 'Tilføj reverse prompt-udvidelse til browseren',
            goComplete: 'Gå',
            completed: 'Fuldført',
            tokens: 'Credits',
            pwaGuideTitle: 'Sæt WeryAI på dit skrivebord',
            pwaGuideDesc: 'Åbner hurtigere, mere fordybende, uden at finde browseren hver gang',
            browserNotSupported: 'Din browser understøtter ikke denne funktion. Brug venligst Chrome, Edge eller Safari',
            pwaStepChrome1: 'Klik på "Tilføj til skrivebord"-ikonet øverst',
            pwaStepChrome2: 'Klik på Installer',
            pwaStepEdge1: 'Klik på "Tilføj til skrivebord"-ikonet øverst',
            pwaStepEdge2: 'Klik på Installer',
            pwaStepSafari1: 'Klik på Mere-ikonet',
            pwaStepSafari2: 'Klik på Del',
            pwaStepSafari3: 'Klik på Mere',
            pwaStepSafari4: 'Klik på Tilføj til startskærm',
            pwaStepSafari5: 'Klik på Tilføj',
            pwaPromptTitle: 'Tilføj WeryAI til skrivebordet',
            pwaPromptDesc: 'Tilføj til startskærm og få 15 point',
            pwaPromptBtn: 'Tilføj',
            extensionNotFound: 'Udvidelse ikke fundet. Installer og aktiver den, før du prøver igen.',
            generatingLink: 'Genererer invitationslink, prøv igen senere',
            copyFailed: 'Kopiering mislykkedes, kopier venligst manuelt',
            installExtensionGuide: 'Installer udvidelsen fra butikken, vend derefter tilbage hertil og klik på "Hent nu" for at bekræfte',
            extensionDetected: 'Udvidelse registreret. Klik for at hente din belønning.',
        },
    },
    no: {
        signIn: {
            inviteFriends: 'Inviter venner',
            todayLimit: 'Dagens grense',
            copyLink: 'Kopier lenke',
            copySuccess: 'Kopiert',
            validInvites: 'Gyldige invitasjoner',
            people: 'personer',
            today: 'I dag',
            pending: 'Venter',
            claimNow: 'Hent nå',
            claimSuccess: 'Hentet',
            claimFailed: 'Henting mislyktes, prøv igjen senere',
            noPendingRewards: 'Ingen belønninger å hente',
            forEachFriend: 'Belønning for å invitere venner til å registrere seg',
            hotBadge: 'HOT',
            signUpsLabel: 'Registreringer',
            rechargeLabel: 'Påfyll',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Venner registrerer seg via lenken din og fullfører',
            inviteRegisterRuleAction: 'én AI-generering',
            inviteRegisterRuleSuffix: 'for å motta belønning.',
            inviteDailyLimitText:
                'Daglig invitasjonsbelønningsgrense er {limit} personer og oppdateres neste dag.',
            inviteFirstChargeTitle: 'Belønning for venners første påfyll',
            inviteFirstChargeNote:
                'Belønningen matches etter beløpsintervallet for den inviterte brukerens første påfyll. Kun første påfyll gjelder, og belønninger kan ikke kombineres.',
            inviteFirstChargeFootnote:
                'Kun første påfyll gjelder, og belønninger kan ikke kombineres.',
            inviteLinkGeneratingTip: 'Invitasjonslenken genereres, prøv igjen senere',
            copyFailedManual: 'Kopiering mislyktes, vennligst kopier manuelt',
            altArrow: 'Pil',
            altSignIn: 'Logg inn',
            altGift: 'Gave',
            altBg: 'Bakgrunn',
            altPrize: 'Premie',
            altSigned: 'Fullført',
            altCoin: 'Mynt',
            ruleText: 'Regel: Vennen din må registrere seg via lenken din og',
            completeGeneration: 'fullføre én AI-generering',
            afterReward: 'for å motta belønning.',
            dailyLimitTip: '* Daglig invitasjonsbelønningsgrense: 10 personer, oppdateres neste dag.',
            promotionText:
                'Vil du bruke nanobanna, VEO, seedream gratis? Registrer deg på WeryAI for å få gratis tokens og opplev gleden ved AI-skaping!',
            taskCenter: 'Oppgavesenter',
            addToDesktop: 'Legg til WeryAI på skrivebordet og få tilgang derfra',
            addExtension: 'Legg til omvendt ledetekst-utvidelse i nettleseren',
            goComplete: 'Gå',
            completed: 'Fullført',
            tokens: 'Credits',
            pwaGuideTitle: 'Sett WeryAI på skrivebordet',
            pwaGuideDesc: 'Åpner raskere, mer engasjerende, uten å finne nettleseren hver gang',
            browserNotSupported: 'Nettleseren din støtter ikke denne funksjonen. Vennligst bruk Chrome, Edge eller Safari',
            pwaStepChrome1: 'Klikk på "Legg til på skrivebordet"-ikonet øverst',
            pwaStepChrome2: 'Klikk på Installer',
            pwaStepEdge1: 'Klikk på "Legg til på skrivebordet"-ikonet øverst',
            pwaStepEdge2: 'Klikk på Installer',
            pwaStepSafari1: 'Klikk på Mer-ikonet',
            pwaStepSafari2: 'Klikk på Del',
            pwaStepSafari3: 'Klikk på Mer',
            pwaStepSafari4: 'Klikk på Legg til på startskjermen',
            pwaStepSafari5: 'Klikk på Legg til',
            pwaPromptTitle: 'Legg til WeryAI på skrivebordet',
            pwaPromptDesc: 'Legg til på startskjermen og få 15 poeng',
            pwaPromptBtn: 'Legg til',
            extensionNotFound: 'Utvidelse ikke funnet. Installer og aktiver den før du prøver på nytt.',
            generatingLink: 'Genererer invitasjonslenke, prøv igjen senere',
            copyFailed: 'Kopiering mislyktes, kopier manuelt',
            installExtensionGuide: 'Installer utvidelsen fra butikken, gå deretter tilbake hit og klikk på "Hent nå" for å bekrefte',
            extensionDetected: 'Utvidelse oppdaget. Klikk for å hente belønningen din.',
        },
    },
    nl: {
        signIn: {
            inviteFriends: 'Vrienden uitnodigen',
            todayLimit: 'Limiet vandaag',
            copyLink: 'Link kopiëren',
            copySuccess: 'Gekopieerd',
            validInvites: 'Geldige uitnodigingen',
            people: 'mensen',
            today: 'Vandaag',
            pending: 'In behandeling',
            claimNow: 'Nu claimen',
            claimSuccess: 'Succesvol geclaimd',
            claimFailed: 'Claimen mislukt, probeer het later opnieuw',
            noPendingRewards: 'Geen beloningen om te claimen',
            forEachFriend: 'Beloning voor het uitnodigen van vrienden om zich te registreren',
            hotBadge: 'HOT',
            signUpsLabel: 'Registraties',
            rechargeLabel: 'Opwaarderingen',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Vrienden registreren zich via je link en voltooien',
            inviteRegisterRuleAction: 'één AI-generatie',
            inviteRegisterRuleSuffix: 'om de beloning te ontvangen.',
            inviteDailyLimitText:
                'De dagelijkse uitnodigingsbeloningslimiet is {limit} personen en wordt de volgende dag vernieuwd.',
            inviteFirstChargeTitle: 'Beloning voor de eerste opwaardering van vrienden',
            inviteFirstChargeNote:
                'De beloning is gebaseerd op de bandbreedte van het bedrag van de eerste opwaardering van de uitgenodigde gebruiker. Alleen de eerste opwaardering telt en beloningen zijn niet stapelbaar.',
            inviteFirstChargeFootnote:
                'Alleen de eerste opwaardering telt en beloningen zijn niet stapelbaar.',
            inviteLinkGeneratingTip:
                'De uitnodigingslink wordt gegenereerd, probeer het later opnieuw',
            copyFailedManual: 'Kopiëren mislukt, kopieer handmatig',
            altArrow: 'Pijl',
            altSignIn: 'Inloggen',
            altGift: 'Cadeau',
            altBg: 'Achtergrond',
            altPrize: 'Prijs',
            altSigned: 'Voltooid',
            altCoin: 'Munt',
            ruleText: 'Regel: Je vriend moet zich registreren via je link en',
            completeGeneration: 'één AI-generatie voltooien',
            afterReward: 'om de beloning te ontvangen.',
            dailyLimitTip: '* Dagelijkse uitnodigingsbeloning limiet: 10 personen, wordt de volgende dag vernieuwd.',
            promotionText:
                'Wil je nanobanna, VEO, seedream gratis gebruiken? Registreer je bij WeryAI om gratis tokens te krijgen en ervaar het plezier van AI-creatie!',
            taskCenter: 'Taakcentrum',
            addToDesktop: 'Voeg WeryAI toe aan bureaublad en open vanaf daar',
            addExtension: 'Voeg reverse prompt-extensie toe aan browser',
            goComplete: 'Ga',
            completed: 'Voltooid',
            tokens: 'Credits',
            pwaGuideTitle: 'Zet WeryAI op je bureaublad',
            pwaGuideDesc: 'Opent sneller, meer meeslepend, zonder elke keer de browser te zoeken',
            browserNotSupported: 'Je browser ondersteunt deze functie niet. Gebruik Chrome, Edge of Safari',
            pwaStepChrome1: 'Klik op het "Toevoegen aan bureaublad"-pictogram bovenaan',
            pwaStepChrome2: 'Klik op Installeren',
            pwaStepEdge1: 'Klik op het "Toevoegen aan bureaublad"-pictogram bovenaan',
            pwaStepEdge2: 'Klik op Installeren',
            pwaStepSafari1: 'Klik op het Meer-pictogram',
            pwaStepSafari2: 'Klik op Delen',
            pwaStepSafari3: 'Klik op Meer',
            pwaStepSafari4: 'Klik op Zet op beginscherm',
            pwaStepSafari5: 'Klik op Voeg toe',
            pwaPromptTitle: 'Voeg WeryAI toe aan bureaublad',
            pwaPromptDesc: 'Voeg toe aan beginscherm en krijg 15 punten',
            pwaPromptBtn: 'Toevoegen',
            extensionNotFound: 'Extensie niet gedetecteerd. Installeer en activeer deze voordat u het opnieuw probeert.',
            generatingLink: 'Uitnodigingslink genereren, probeer het later opnieuw',
            copyFailed: 'Kopiëren mislukt, kopieer handmatig',
            installExtensionGuide: 'Installeer de extensie uit de store, kom dan hier terug en klik op "Nu claimen" om te verifiëren',
            extensionDetected: 'Extensie gedetecteerd. Klik om je beloning te claimen.',
        },
    },
    id: {
        signIn: {
            inviteFriends: 'Undang Teman',
            todayLimit: 'Batas Hari Ini',
            copyLink: 'Salin Tautan',
            copySuccess: 'Disalin',
            validInvites: 'Undangan Valid',
            people: 'orang',
            today: 'Hari ini',
            pending: 'Tertunda',
            claimNow: 'Klaim Sekarang',
            claimSuccess: 'Berhasil diklaim',
            claimFailed: 'Gagal klaim, coba lagi nanti',
            noPendingRewards: 'Tidak ada hadiah untuk diklaim',
            forEachFriend: 'Hadiah untuk mengundang teman mendaftar',
            hotBadge: 'HOT',
            signUpsLabel: 'Pendaftaran',
            rechargeLabel: 'Isi ulang',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Teman mendaftar melalui tautan Anda dan menyelesaikan',
            inviteRegisterRuleAction: 'satu generasi AI',
            inviteRegisterRuleSuffix: 'untuk menerima hadiah.',
            inviteDailyLimitText:
                'Batas hadiah undangan harian adalah {limit} orang dan diperbarui keesokan harinya.',
            inviteFirstChargeTitle: 'Hadiah untuk isi ulang pertama teman',
            inviteFirstChargeNote:
                'Hadiah ditentukan berdasarkan rentang jumlah isi ulang pertama pengguna yang diundang. Hanya isi ulang pertama yang berlaku dan hadiah tidak dapat ditumpuk.',
            inviteFirstChargeFootnote:
                'Hanya isi ulang pertama yang berlaku dan hadiah tidak dapat ditumpuk.',
            inviteLinkGeneratingTip:
                'Tautan undangan sedang dibuat, silakan coba lagi nanti',
            copyFailedManual: 'Gagal menyalin, silakan salin secara manual',
            altArrow: 'Panah',
            altSignIn: 'Masuk',
            altGift: 'Hadiah',
            altBg: 'Latar belakang',
            altPrize: 'Hadiah',
            altSigned: 'Selesai',
            altCoin: 'Koin',
            ruleText: 'Aturan: Teman harus mendaftar melalui tautan Anda dan',
            completeGeneration: 'menyelesaikan satu generasi AI',
            afterReward: 'untuk menerima hadiah.',
            dailyLimitTip: '* Batas hadiah undangan harian: 10 orang, diperbarui keesokan harinya.',
            promotionText:
                'Ingin menggunakan nanobanna, VEO, seedream gratis? Daftar di WeryAI untuk mendapatkan token gratis dan rasakan kegembiraan kreasi AI!',
            taskCenter: 'Pusat Tugas',
            addToDesktop: 'Tambahkan WeryAI ke desktop dan akses dari sana',
            addExtension: 'Tambahkan ekstensi prompt terbalik ke browser',
            goComplete: 'Pergi',
            completed: 'Selesai',
            tokens: 'Kredit',
            pwaGuideTitle: 'Letakkan WeryAI di Desktop',
            pwaGuideDesc: 'Buka lebih cepat, lebih imersif, tanpa perlu mencari browser setiap saat',
            browserNotSupported: 'Browser Anda tidak mendukung fitur ini. Silakan gunakan Chrome, Edge, atau Safari',
            pwaStepChrome1: 'Klik ikon "Tambahkan ke Desktop" di bagian atas',
            pwaStepChrome2: 'Klik Instal',
            pwaStepEdge1: 'Klik ikon "Tambahkan ke Desktop" di bagian atas',
            pwaStepEdge2: 'Klik Instal',
            pwaStepSafari1: 'Klik ikon Lainnya',
            pwaStepSafari2: 'Klik Bagikan',
            pwaStepSafari3: 'Klik Lainnya',
            pwaStepSafari4: 'Klik Tambahkan ke Layar Utama',
            pwaStepSafari5: 'Klik Tambahkan',
            pwaPromptTitle: 'Tambahkan WeryAI ke Desktop',
            pwaPromptDesc: 'Tambahkan ke layar utama dan dapatkan 15 poin',
            pwaPromptBtn: 'Tambahkan',
            extensionNotFound: 'Ekstensi tidak terdeteksi. Silakan instal dan aktifkan sebelum mencoba lagi.',
            generatingLink: 'Menghasilkan tautan undangan, silakan coba lagi nanti',
            copyFailed: 'Gagal menyalin, silakan salin secara manual',
            installExtensionGuide: 'Silakan instal ekstensi dari toko, lalu kembali ke sini dan klik "Klaim Sekarang" untuk memverifikasi',
            extensionDetected: 'Ekstensi terdeteksi. Klik untuk mengklaim hadiah Anda.',
        },
    },
    tr: {
        signIn: {
            inviteFriends: 'Arkadaş Davet Et',
            todayLimit: 'Bugünkü Limit',
            copyLink: 'Bağlantıyı Kopyala',
            copySuccess: 'Kopyalandı',
            validInvites: 'Geçerli Davetler',
            people: 'kişi',
            today: 'Bugün',
            pending: 'Bekliyor',
            claimNow: 'Şimdi Al',
            claimSuccess: 'Başarıyla alındı',
            claimFailed: 'Alma başarısız, daha sonra tekrar deneyin',
            noPendingRewards: 'Alınacak ödül yok',
            forEachFriend: 'Arkadaşları kayıt olmaya davet etme ödülü',
            hotBadge: 'HOT',
            signUpsLabel: 'Kayıtlar',
            rechargeLabel: 'Yüklemeler',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Arkadaşlar bağlantınız üzerinden kaydolur ve',
            inviteRegisterRuleAction: 'bir AI üretimini',
            inviteRegisterRuleSuffix: 'tamamlayarak ödülü alır.',
            inviteDailyLimitText: 'Günlük davet ödül limiti {limit} kişidir ve ertesi gün yenilenir.',
            inviteFirstChargeTitle: 'Arkadaşların ilk yükleme ödülü',
            inviteFirstChargeNote:
                'Ödül, davet edilen kullanıcının ilk yükleme tutarı aralığına göre belirlenir. Yalnızca ilk yükleme geçerlidir ve ödüller birleştirilemez.',
            inviteFirstChargeFootnote:
                'Yalnızca ilk yükleme geçerlidir ve ödüller birleştirilemez.',
            inviteLinkGeneratingTip:
                'Davet bağlantısı oluşturuluyor, lütfen daha sonra tekrar deneyin',
            copyFailedManual: 'Kopyalama başarısız, lütfen manuel olarak kopyalayın',
            altArrow: 'Ok',
            altSignIn: 'Giriş',
            altGift: 'Hediye',
            altBg: 'Arka plan',
            altPrize: 'Ödül',
            altSigned: 'Tamamlandı',
            altCoin: 'Madeni para',
            ruleText: 'Kural: Arkadaşınız bağlantınız üzerinden kaydolmalı ve',
            completeGeneration: 'bir AI üretimi tamamlamalı',
            afterReward: 'ödülü almak için.',
            dailyLimitTip: '* Günlük davet ödül limiti: 10 kişi, ertesi gün yenilenir.',
            promotionText:
                'nanobanna, VEO, seedream\'i ücretsiz kullanmak ister misiniz? WeryAI\'ye kaydolun, ücretsiz token kazanın ve AI yaratıcılığının keyfini çıkarın!',
            taskCenter: 'Görev Merkezi',
            addToDesktop: 'WeryAI\'yi masaüstüne ekle ve oradan eriş',
            addExtension: 'Tarayıcıya ters istem uzantısı ekle',
            goComplete: 'Git',
            completed: 'Tamamlandı',
            tokens: 'Kredi',
            pwaGuideTitle: 'WeryAI\'yi Masaüstüne Koy',
            pwaGuideDesc: 'Daha hızlı açılır, daha sürükleyici, her seferinde tarayıcı aramaya gerek yok',
            browserNotSupported: 'Tarayıcınız bu özelliği desteklemiyor. Lütfen Chrome, Edge veya Safari kullanın',
            pwaStepChrome1: 'Üstteki "Masaüstüne Ekle" simgesine tıklayın',
            pwaStepChrome2: 'Yükle\'ye tıklayın',
            pwaStepEdge1: 'Üstteki "Masaüstüne Ekle" simgesine tıklayın',
            pwaStepEdge2: 'Yükle\'ye tıklayın',
            pwaStepSafari1: 'Daha Fazla simgesine tıklayın',
            pwaStepSafari2: 'Paylaş\'a tıklayın',
            pwaStepSafari3: 'Daha Fazla\'ya tıklayın',
            pwaStepSafari4: 'Ana Ekrana Ekle\'ye tıklayın',
            pwaStepSafari5: 'Ekle\'ye tıklayın',
            pwaPromptTitle: 'WeryAI\'yi Masaüstüne Ekle',
            pwaPromptDesc: 'Ana ekrana ekle ve 15 puan kazan',
            pwaPromptBtn: 'Ekle',
            extensionNotFound: 'Uzantı algılanmadı. Lütfen tekrar denemeden önce yükleyin ve etkinleştirin.',
            generatingLink: 'Davet bağlantısı oluşturuluyor, lütfen daha sonra tekrar deneyin',
            copyFailed: 'Kopyalama başarısız, lütfen manuel olarak kopyalayın',
            installExtensionGuide: 'Lütfen uzantıyı mağazadan yükleyin, ardından buraya dönün ve doğrulamak için "Şimdi Al"a tıklayın',
            extensionDetected: 'Uzantı algılandı. Ödülünüzü almak için tıklayın.',
        },
    },
    pl: {
        signIn: {
            inviteFriends: 'Zaproś znajomych',
            todayLimit: 'Dzisiejszy limit',
            copyLink: 'Kopiuj link',
            copySuccess: 'Skopiowano',
            validInvites: 'Ważne zaproszenia',
            people: 'osób',
            today: 'Dzisiaj',
            pending: 'Oczekuje',
            claimNow: 'Odbierz teraz',
            claimSuccess: 'Odebrano pomyślnie',
            claimFailed: 'Odbiór nie powiódł się, spróbuj ponownie później',
            noPendingRewards: 'Brak nagród do odebrania',
            forEachFriend: 'Nagroda za zaproszenie znajomych do rejestracji',
            hotBadge: 'HOT',
            signUpsLabel: 'Rejestracje',
            rechargeLabel: 'Doładowania',
            loadingDots: '...',
            inviteLinkPlaceholder: 'weryai.com/?invite_code=...',
            inviteRegisterRulePrefix: 'Znajomi rejestrują się przez Twój link i wykonują',
            inviteRegisterRuleAction: 'jedną generację AI',
            inviteRegisterRuleSuffix: 'aby otrzymać nagrodę.',
            inviteDailyLimitText:
                'Dzienny limit nagród za zaproszenia to {limit} osób, odświeża się następnego dnia.',
            inviteFirstChargeTitle: 'Nagroda za pierwsze doładowanie znajomych',
            inviteFirstChargeNote:
                'Nagroda zależy od przedziału kwoty pierwszego doładowania zaproszonego użytkownika. Liczy się tylko pierwsze doładowanie, a nagrody nie sumują się.',
            inviteFirstChargeFootnote:
                'Liczy się tylko pierwsze doładowanie, a nagrody nie sumują się.',
            inviteLinkGeneratingTip:
                'Link zaproszenia jest generowany, spróbuj ponownie później',
            copyFailedManual: 'Kopiowanie nie powiodło się, skopiuj ręcznie',
            altArrow: 'Strzałka',
            altSignIn: 'Zaloguj się',
            altGift: 'Prezent',
            altBg: 'Tło',
            altPrize: 'Nagroda',
            altSigned: 'Ukończone',
            altCoin: 'Moneta',
            ruleText: 'Zasada: Znajomy musi zarejestrować się przez Twój link i',
            completeGeneration: 'ukończyć jedną generację AI',
            afterReward: 'aby otrzymać nagrodę.',
            dailyLimitTip: '* Dzienny limit nagród za zaproszenia: 10 osób, odświeża się następnego dnia.',
            promotionText:
                'Chcesz używać nanobanna, VEO, seedream za darmo? Zarejestruj się w WeryAI, aby otrzymać darmowe tokeny i doświadczyć radości tworzenia z AI!',
            taskCenter: 'Centrum zadań',
            addToDesktop: 'Dodaj WeryAI do pulpitu i uzyskaj dostęp stamtąd',
            addExtension: 'Dodaj rozszerzenie odwrotnego promptu do przeglądarki',
            goComplete: 'Idź',
            completed: 'Ukończone',
            tokens: 'Kredyty',
            pwaGuideTitle: 'Umieść WeryAI na pulpicie',
            pwaGuideDesc: 'Otwiera się szybciej, bardziej wciągające, bez szukania przeglądarki za każdym razem',
            browserNotSupported: 'Twoja przeglądarka nie obsługuje tej funkcji. Użyj Chrome, Edge lub Safari',
            pwaStepChrome1: 'Kliknij ikonę "Dodaj do pulpitu" na górze',
            pwaStepChrome2: 'Kliknij Zainstaluj',
            pwaStepEdge1: 'Kliknij ikonę "Dodaj do pulpitu" na górze',
            pwaStepEdge2: 'Kliknij Zainstaluj',
            pwaStepSafari1: 'Kliknij ikonę Więcej',
            pwaStepSafari2: 'Kliknij Udostępnij',
            pwaStepSafari3: 'Kliknij Więcej',
            pwaStepSafari4: 'Kliknij Dodaj do ekranu głównego',
            pwaStepSafari5: 'Kliknij Dodaj',
            pwaPromptTitle: 'Dodaj WeryAI do pulpitu',
            pwaPromptDesc: 'Dodaj do ekranu głównego i zdobądź 15 punktów',
            pwaPromptBtn: 'Dodaj',
            extensionNotFound: 'Nie wykryto rozszerzenia. Zainstaluj i włącz je przed ponowną próbą.',
            generatingLink: 'Generowanie linku zaproszenia, spróbuj ponownie później',
            copyFailed: 'Kopiowanie nie powiodło się, skopiuj ręcznie',
            installExtensionGuide: 'Zainstaluj rozszerzenie ze sklepu, a następnie wróć tutaj i kliknij „Odbierz teraz”, aby zweryfikować',
            extensionDetected: 'Wykryto rozszerzenie. Kliknij, aby odebrać nagrodę.',
        },
    },
}
